import useRouter from './useRouter'
import { alertSourceOf } from '../utils/alertSources'
import type { AlertRule } from '../types/gotypes'

/**
 * Opens the agent start screen with a table or question alert's card filled
 * in (`/agent/:customer/new?alert=<id>`), where the user can change it and
 * Send opens the chat whose agent writes, tests and saves the check (Alerts
 * page, alert detail, the edit dialog's "Change with the agent"). An event
 * alert has no check, so it never opens one. Nothing is created here: the
 * start screen's Send saves any change, creates the session on the alert's
 * job and ties it to the rule.
 */
export function useAlertSetupSession(customer: string) {
  const router = useRouter()

  const startSetup = (alert: AlertRule): boolean => {
    if (!customer || alertSourceOf(alert).kind === 'event') return false
    router.navigate('agent-new', { customer, alert: alert.id })
    return true
  }

  /** New alert: the start screen with an empty card. */
  const startNew = () => {
    if (!customer) return
    router.navigate('agent-new', { customer, alert: 'new' })
  }

  return { startSetup, startNew }
}

export default useAlertSetupSession
